<template>
  <div class="tab-dialog-box" style="position: relative;">
    <el-tabs v-model="activeFragmentId" >
      <el-tab-pane label="草稿详情" name="specialistPage" style="width: 100%;"        >
        <el-scrollbar class="custom-scroll" :style="{height: getTabPaneHeight + 'px'}">
          <el-form ref="specialistPage" :model="formData" class="full-width-input" style="width: 100%;" :rules="rules"
            label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
            <div v-if="formData.Specialist.specialistType !=='4' ">
              <el-row :gutter="20">
                <!--            <el-col :span="6">-->
                <!--              <el-form-item label="个人名称" prop="Specialist.userName">-->
                <!--                <el-input class="input-item"  v-model="formData.Specialist.userName"-->
                <!--                           placeholder="个人名称"-->
                <!--                />-->
                <!--                <span class="input-item input-label" v-else>{{formData.Specialist.userName}}</span>-->
                <!--              </el-form-item>-->
                <!--            </el-col>-->
                <el-col :span="8" v-if="formData.Specialist.specialistNo">
                  <el-form-item label="专家编号" prop="Specialist.specialistNo">
                    <el-input   class="input-item"  v-model="formData.Specialist.specialistNo"
                                readOnly
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="myLabel.specialistNameLabel" prop="Specialist.specialistName">
                    <el-input class="input-item"  v-model="formData.Specialist.specialistName"
                             readOnly
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件类型" prop="Specialist.documentType">
                    <el-select class="input-item"  v-model="formData.Specialist.documentType" disabled
                               filterable
                               :loading="flowSpecialistAuditForm.documentType.impl.loading"
                               @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                               @change="onDocumentTypeValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证号码" prop="Specialist.idCard">
                    <el-input class="input-item"  v-model="formData.Specialist.idCard" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份" prop="Specialist.identity">
                    <el-select class="input-item"  v-model="formData.Specialist.identity"  filterable disabled
                               :loading="flowSpecialistAuditForm.identity.impl.loading"
                               @visible-change="flowSpecialistAuditForm.identity.impl.onVisibleChange"
                               @change="onIdentityValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.identity.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="籍贯" prop="Specialist.nativePlace">
                    <el-input class="input-item"  v-model="formData.Specialist.nativePlace" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="区级" prop="Specialist.isDistrict">
                    <el-select class="input-item"  v-model="formData.Specialist.isDistrict"  filterable disabled
                              :loading="flowSpecialistAuditForm.isDistrict.impl.loading"
                               @visible-change="flowSpecialistAuditForm.isDistrict.impl.onVisibleChange"
                               @change="onIsDistrictValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.isDistrict.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="政治面貌" prop="Specialist.politicalOutlook">
                    <el-input class="input-item"  v-model="formData.Specialist.politicalOutlook" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="性别" prop="Specialist.gender">
                    <el-select class="input-item" v-model="formData.Specialist.gender"  filterable disabled
                             :loading="flowSpecialistAuditForm.gender.impl.loading"
                               @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange"
                               @change="onGenderValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="出生日期" prop="Specialist.birthday">
                    <el-date-picker class="input-item"  v-model="formData.Specialist.birthday" readOnly disabled
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产业" prop="Specialist.industryId">
                    <el-cascader class="input-item"  v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                                 :show-all-levels="false"  disabled
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                                 @change="onIndustryIdValueChange"
                    />
                  </el-form-item>
                </el-col>
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="单位性质" prop="Specialist.companyProperties">-->
<!--                    <el-input class="input-item"  v-model="formData.Specialist.companyProperties" readOnly-->

<!--                    />-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="服务单位" prop="Specialist.serviceCompany">-->
<!--                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany" readOnly-->

<!--                    />-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
<!--                <el-col :span="8">-->
<!--                  <el-form-item label="工作单位（编制）属地" prop="Specialist.companyArea">-->
<!--                    <el-input class="input-item"  v-model="formData.Specialist.companyArea" readOnly-->

<!--                    />-->
<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="8">
                  <el-form-item label="学术称号" prop="Specialist.academicTitle">
                    <el-input class="input-item"  v-model="formData.Specialist.academicTitle" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="电子邮箱" prop="Specialist.email">
                    <el-input class="input-item"  v-model="formData.Specialist.email" readOnly

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="学历" prop="Specialist.education">
                    <el-select class="input-item"  v-model="formData.Specialist.education"  filterable disabled
                                :loading="flowSpecialistAuditForm.education.impl.loading"
                               @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                               @change="onEducationValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="学位" prop="Specialist.degreeLevel">
                    <el-select class="input-item"  v-model="formData.Specialist.degreeLevel"  filterable disabled
                                :loading="flowSpecialistAuditForm.degreeLevel.impl.loading"
                               @visible-change="flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange"
                               @change="onDegreeLevelValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.degreeLevel.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="职称" prop="Specialist.specialistTitleId">
                    <el-select class="input-item"  v-model="formData.Specialist.specialistTitleId"  filterable disabled
                               :loading="flowSpecialistAuditForm.specialistTitleId.impl.loading"
                               @visible-change="flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange"
                               @change="onSpecialistTitleIdValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.specialistTitleId.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="联系电话" prop="Specialist.mobilePhone">
                    <el-input class="input-item"  v-model="formData.Specialist.mobilePhone" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="工作单位（编制）" prop="Specialist.companyName">
                    <el-input class="input-item"  v-model="formData.Specialist.companyName" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="统一社会信用代码" prop="Specialist.creditCode">
                    <el-input class="input-item"  v-model="formData.Specialist.creditCode" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位性质" prop="Specialist.companyProperties">
                    <el-input class="input-item"  v-model="formData.Specialist.companyProperties" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="工作单位（编制）属地" prop="Specialist.companyArea">
                    <el-input class="input-item"  v-model="formData.Specialist.companyArea" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="职位" prop="Specialist.companyPost">
                    <el-input class="input-item"  v-model="formData.Specialist.companyPost" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位联系人" prop="Specialist.companyContacts">
                    <el-input class="input-item"  v-model="formData.Specialist.companyContacts" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位联系电话" prop="Specialist.companyTel">
                    <el-input class="input-item"  v-model="formData.Specialist.companyTel" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务单位" prop="Specialist.serviceCompany">
                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany" readOnly

                    />
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row v-if="formData.Specialist.isDistrict === '1'">
                <!--            <div  >-->
                <el-col :span="8">
                  <el-form-item label="工作经费（元）" prop="Specialist.workingFunds">
                    <el-input-number class="input-item"  v-model="formData.Specialist.workingFunds" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="拨付渠道" prop="Specialist.appropriateChannel"
                                v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                    <el-select class="input-item"  v-model="formData.Specialist.appropriateChannel"  filterable disabled
                              :loading="flowSpecialistAuditForm.appropriateChannel.impl.loading"
                               @visible-change="flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange"
                               @change="onAppropriateChannelValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.appropriateChannel.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="经费拨至单位" prop="Specialist.fundsToCompany"
                                v-if="formData.Specialist.workingFunds && formData.Specialist.workingFunds>0">
                    <el-input class="input-item"  v-model="formData.Specialist.fundsToCompany" readOnly

                    />
                  </el-form-item>
                </el-col>
                <!--            </div>-->
              </el-row>
              <el-row>
                <el-col :span="4">
                  <el-form-item :label="myLabel.specialistAvatarLabel" prop="Specialist.specialistAvatar">
                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.specialistAvatar, {id: formData.Specialist.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.specialistAvatar, {id: formData.Specialist.id, fieldName: 'specialistAvatar', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="身份证正面" prop="Specialist.idPhoto">
                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.idPhoto.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.idPhoto, {id: formData.Specialist.id,
                  fieldName: 'idPhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.idPhoto, {id: formData.Specialist.id, fieldName: 'idPhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="4" >
                  <el-form-item label="学历资料" prop="Specialist.educationalFile">

                    <template>
<!--                      <img v-for="item in flowSpecialistAuditForm.educationalFile.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.educationalFile, {id: formData.Specialist.id,
                  fieldName: 'educationalFile', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.educationalFile, {id: formData.Specialist.id, fieldName: 'educationalFile', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="4" >
                  <el-form-item label="学位资料" prop="Specialist.degreeFiles">

                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.degreeFiles.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.degreeFiles, {id: formData.Specialist.id,
                  fieldName: 'degreeFiles', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.degreeFiles, {id: formData.Specialist.id, fieldName: 'degreeFiles', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="4" >
                  <el-form-item label="职称资料" prop="Specialist.positionalFiles">

                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.positionalFiles.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.positionalFiles, {id: formData.Specialist.id,
                  fieldName: 'positionalFiles', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.positionalFiles, {id: formData.Specialist.id, fieldName: 'positionalFiles', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="4" >
                  <el-form-item label="服务单位营业执照" prop="Specialist.servicePhoto">

                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.servicePhoto, {id: formData.Specialist.id,
                  fieldName: 'servicePhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.servicePhoto, {id: formData.Specialist.id, fieldName: 'servicePhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="类型" prop="Specialist.specialistType">
                    <el-radio-group class="input-item"  v-model="formData.Specialist.specialistType" disabled
                                    @change="onSpecialistTypeValueChange"
                    >
                      <el-radio v-for="item in flowSpecialistAuditForm.specialistType.impl.dropdownList" :key="item.id"
                                :label="item.id"
                      >
                        {{item.name}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12" v-show="formData.Specialist.specialistType=='2'">
                  <el-form-item label="团队名称" prop="Specialist.teamName">
                    <el-input class="input-item"  v-model="formData.Specialist.teamName" readOnly

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="6" v-show="formData.Specialist.specialistType=='3'">
                  <el-form-item label="法人识别号" prop="Specialist.identityCardNo">
                    <el-input class="input-item"  v-model="formData.Specialist.identityCardNo" readOnly

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24" >
                  <el-form-item label="专业领域" prop="Specialist.specializedField">
                    <el-input class="input-item" v-model="formData.Specialist.specializedField" readOnly
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"

                    />
                  </el-form-item>
                </el-col>

                <el-col :span="24">
                  <el-form-item :label="myLabel.specialistSpecialLabel" prop="Specialist.specialistSpecial">
                    <rich-editor ref="specialistSpecial" class="input-item" disabled
                                 v-model="formData.Specialist.specialistSpecial"  />
                  </el-form-item>
                </el-col>

                <el-col :span="24" v-show="true">

                  <el-form-item label="附件" prop="Specialist.otherFiles">

                    <template>
                      <a v-for="item in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"
                         href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                        {{item.name}}
                      </a>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-show="formData.Specialist.specialistType=='2'">
                  <el-row type="flex" justify="space-between" align="middle" style="margin-bottom: 15px;">
                    <div class="table-title" style="padding-left: 5px; border-left: 3px solid #409EFF;">成员信息</div>
                    <!-- 表格操作 -->
                    <div>
                    </div>
                  </el-row>
                </el-col>
                <!--              <el-col :span="24" v-show="formData.Specialist.specialistType=='2'">-->
                <!--                <filter-box :item-width="350">-->
                <!--                  <el-button slot="operator" type="primary" :size="defaultFormItemSize"-->
                <!--                             @click="addSpecialistMember()"  >-->
                <!--                    新增成员-->
                <!--                  </el-button>-->
                <!--                </filter-box>-->
                <!--              </el-col>-->
                <template v-show="formData.Specialist.specialistType=='2'">
                  <el-table ref="specialistMember" :data="flowSpecialistAuditForm.SpecialistMember.impl.dataList" :size="defaultFormItemSize" @sort-change="flowSpecialistAuditForm.SpecialistMember.impl.onSortChange"
                            header-cell-class-name="table-header-gray" v-show="formData.Specialist.specialistType=='2'"
                  >
                    <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="flowSpecialistAuditForm.SpecialistMember.impl.getTableIndex" />
                    <el-table-column label="专家名称" prop="specialistName">
                    </el-table-column>
                    <el-table-column label="专家照片" min-width="100px">
                      <template slot-scope="scope">
                        <el-image v-for="item in parseUploadData(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                                  :preview-src-list="getPictureList(scope.row.specialistAvatar, {id: scope.row.id, fieldName: 'specialistAvatar', asImage: true})"
                                  class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                          <div slot="error" class="table-cell-image">
                            <i class="el-icon-picture-outline"></i>
                          </div>
                        </el-image>
                      </template>
                    </el-table-column>
                    <el-table-column label="联系电话" prop="mobilePhone">
                    </el-table-column>
                    <el-table-column label="产业" prop="industryName">
                    </el-table-column>
                    <el-table-column label="职称" prop="specialistTitle">
                    </el-table-column>

                  </el-table>
                  <el-row type="flex" justify="end" style="margin-top: 10px;" v-show="formData.Specialist.specialistType=='2'">
                    <el-pagination @size-change="handleSizeChange"
                                   @current-change="handleCurrentChange"
                                   :current-page="currentPage"
                                   :page-sizes="pageSizes"
                                   :page-size="PageSize" layout="total, sizes, prev, pager, next, jumper"
                                   :total="flowSpecialistAuditForm.SpecialistMember.impl.totalCount">
                    </el-pagination>
                  </el-row>
                </template>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="服务对象" prop="SpecialistHis.serviceObjectName">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceObjectName" readOnly

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务地区" prop="SpecialistHis.serviceAreaId">
                    <el-cascader class="input-item"  v-model="formData.SpecialistHis.serviceAreaId"
                                 style="color: #303133"
                                 :options="signContractWin.serviceAreaId.impl.dropdownList" filterable disabled
                                 :show-all-levels="true"
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="signContractWin.serviceAreaId.impl.onVisibleChange"
                                 @change="onServiceAreaIdValueChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务详细地址" prop="SpecialistHis.serviceAddress">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceAddress" readOnly

                    />

                  </el-form-item>
                </el-col>

                <el-col :span="12">
                  <el-form-item label="联系人" prop="SpecialistHis.contactsUser">
                    <el-input class="input-item" v-model="formData.SpecialistHis.contactsUser" readOnly

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="联系电话" prop="SpecialistHis.contactsUserTel">
                    <el-input class="input-item" v-model="formData.SpecialistHis.contactsUserTel" readOnly

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="主营业务" prop="SpecialistHis.mainBusiness">
                    <el-input class="input-item" v-model="formData.SpecialistHis.mainBusiness" readOnly
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"

                    />

                  </el-form-item>
                </el-col>
<!--                <el-col :span="12">-->
<!--                  <el-form-item label="服务期" prop="SpecialistHis.signYear">-->
<!--                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYear" disabled-->
<!--                                    format="yyyy"-->
<!--                                    value-format="yyyy-MM-dd"-->
<!--                                    type="year" align="left"-->

<!--                    />-->

<!--                  </el-form-item>-->
<!--                </el-col>-->
                <el-col :span="12">
                  <el-form-item label="服务期起止" prop="SpecialistHis.signYearStart">
                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearStart"
                                    :clearable="true" disabled
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"
                                    placeholder="服务期起止"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务期结束" prop="SpecialistHis.signYearEnd">
                    <el-date-picker class="input-item" v-model="formData.SpecialistHis.signYearEnd" :clearable="true" disabled
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"
                                    placeholder="服务期结束"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="服务对象需求" prop="SpecialistHis.serviceUserRequirement">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceUserRequirement" readOnly

                    />

                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务方式" prop="SpecialistHis.serviceType">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceType" readOnly
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"
                    />

                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务内容" prop="SpecialistHis.serviceContent">
                    <el-input class="input-item" v-model="formData.SpecialistHis.serviceContent" readOnly
                              type="textarea"
                              :autosize="{minRows: 4, maxRows: 8}"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="三方协议书" prop="SpecialistHis.contractFiles">

                    <template >
                      <a v-for="item in signContractWin.contractFiles.impl.fileList" :key="item.url"
                         href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                        {{item.name}}
                      </a>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="服务其他附件" prop="SpecialistHis.attachedFiles">

                    <template >
                      <a v-for="item in signContractWin.attachedFiles.impl.fileList" :key="item.url"
                         href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                        {{item.name}}
                      </a>
                    </template>
                  </el-form-item>
                </el-col>

              </el-row>
            </div>
            <div v-if="formData.Specialist.specialistType ==='4'">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="类型" prop="Specialist.specialistType">
                    <el-radio-group class="input-item"  v-model="formData.Specialist.specialistType" disabled
                                    @change="onSpecialistTypeValueChange"
                    >
                      <el-radio v-for="item in flowSpecialistAuditForm.specialistType.impl.dropdownList" :key="item.id"
                                :label="item.id"
                      >
                        {{item.name}}
                      </el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="8" v-if="formData.Specialist.specialistNo">
                  <el-form-item label="专家编号" prop="Specialist.specialistNo">
                    <el-input   class="input-item"  v-model="formData.Specialist.specialistNo"
                                readOnly
                    />
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item :label="myLabel.specialistNameLabel" prop="Specialist.specialistName">
                    <el-input class="input-item"  v-model="formData.Specialist.specialistName"
                              readOnly
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="证件类型" prop="Specialist.documentType">
                    <el-select class="input-item"  v-model="formData.Specialist.documentType" disabled
                               filterable
                               :loading="flowSpecialistAuditForm.documentType.impl.loading"
                               @visible-change="flowSpecialistAuditForm.documentType.impl.onVisibleChange"
                               @change="onDocumentTypeValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.documentType.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="身份证号码" prop="Specialist.idCard">
                    <el-input class="input-item"  v-model="formData.Specialist.idCard" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="性别" prop="Specialist.gender">
                    <el-select class="input-item" v-model="formData.Specialist.gender"  filterable disabled
                               :loading="flowSpecialistAuditForm.gender.impl.loading"
                               @visible-change="flowSpecialistAuditForm.gender.impl.onVisibleChange"
                               @change="onGenderValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.gender.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="出生日期" prop="Specialist.birthday">
                    <el-date-picker class="input-item"  v-model="formData.Specialist.birthday" readOnly disabled
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date" align="left"

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产业" prop="Specialist.industryId">
                    <el-cascader class="input-item"  v-model="formData.Specialist.industryId" :options="flowSpecialistAuditForm.industryId.impl.dropdownList" filterable
                                 :show-all-levels="false"  disabled
                                 :props="{value: 'id', label: 'name', checkStrictly: true}"
                                 @visible-change="flowSpecialistAuditForm.industryId.impl.onVisibleChange"
                                 @change="onIndustryIdValueChange"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="学历" prop="Specialist.education">
                    <el-select class="input-item"  v-model="formData.Specialist.education"  filterable disabled
                               :loading="flowSpecialistAuditForm.education.impl.loading"
                               @visible-change="flowSpecialistAuditForm.education.impl.onVisibleChange"
                               @change="onEducationValueChange">
                      <el-option v-for="item in flowSpecialistAuditForm.education.impl.dropdownList" :key="item.id"
                                 :value="item.id" :label="item.name"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="工作单位（编制）" prop="Specialist.companyName">
                    <el-input class="input-item"  v-model="formData.Specialist.companyName" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8" >
                  <el-form-item label="统一社会信用代码" prop="Specialist.creditCode">
                    <el-input class="input-item"  v-model="formData.Specialist.creditCode" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="单位联系电话" prop="Specialist.companyTel">
                    <el-input class="input-item"  v-model="formData.Specialist.companyTel" readOnly

                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="服务单位" prop="Specialist.serviceCompany">
                    <el-input class="input-item"  v-model="formData.Specialist.serviceCompany" readOnly

                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="6">
                  <el-form-item label="照片" prop="Specialist.specialistAvatar">
                    <template >
<!--                      <img v-for="item in flowSpecialistAuditForm.specialistAvatar.impl.fileList" :key="item.url"-->
<!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.specialistAvatar, {id: formData.Specialist.id,
                  fieldName: 'specialistAvatar', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.specialistAvatar, {id: formData.Specialist.id, fieldName: 'specialistAvatar', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="身份证正面" prop="Specialist.idPhoto">
                    <template >
                      <!--                      <img v-for="item in flowSpecialistAuditForm.idPhoto.impl.fileList" :key="item.url"-->
                      <!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.idPhoto, {id: formData.Specialist.id,
                  fieldName: 'idPhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.idPhoto, {id: formData.Specialist.id, fieldName: 'idPhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="6" >
                  <el-form-item label="服务单位营业执照" prop="Specialist.servicePhoto">

                    <template >
                      <!--                      <img v-for="item in flowSpecialistAuditForm.servicePhoto.impl.fileList" :key="item.url"-->
                      <!--                           class="table-cell-image" :src="item.url" />-->
                      <el-image v-for="item in parseUploadData(formData.Specialist.servicePhoto, {id: formData.Specialist.id,
                  fieldName: 'servicePhoto', asImage: true})"
                                :preview-src-list="getPictureList(formData.Specialist.servicePhoto, {id: formData.Specialist.id, fieldName: 'servicePhoto', asImage: true})"
                                class="table-cell-image" :key="item.url" :src="item.url" :fit="fit">
                        <div slot="error" class="table-cell-image">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </template>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="专长" prop="Specialist.specialistSpecial">
                    <rich-editor ref="specialistSpecial" class="input-item" disabled
                                 v-model="formData.Specialist.specialistSpecial"  />
                  </el-form-item>
                </el-col>
                <el-col :span="24" v-show="true">

                  <el-form-item label="成果与荣誉" prop="Specialist.otherFiles">

                    <template>
                      <a v-for="item in flowSpecialistAuditForm.otherFiles.impl.fileList" :key="item.url"
                         href="javascript:void(0);" @click="previewFile(item.url, item.filename)">
                        {{item.name}}
                      </a>
                    </template>
                  </el-form-item>
                </el-col>
              </el-row>

            </div>
          </el-form>
        </el-scrollbar>
      </el-tab-pane>
    </el-tabs>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistHisController, SpecialistInfoController, DictionaryController, SpecialistEveryoneController } from '@/api';
import signContractWin from '@/views/specialist/signContractWin.vue';
import specialistMemberEdit from './specialistMemberEdit';
import specialistMemberForm from './specialistMemberForm';
// import {formatDate} from "element-ui/src/utils/date-util";

export default {
  name: 'specialistInfoView',
  props: {
    id: {
      default: undefined
    },
    viewFlag: {
      default: undefined
    },
    processInstanceId: {
      default: undefined
    },
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      // 默认显示第几页
      currentPage: 1,
      // 总条数
      totalCount: 1,
      // 个数选择器
      pageSizes: [10, 15, 20, 30],
      // 默认每页显示的条数
      PageSize: 10,
      activeFragmentId: 'specialistPage',
      formData: {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        },
        Specialist: {
          specialistMemberList: [],
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistType: undefined,
          specialistName: undefined,
          teamName: undefined,
          specialistAvatar: undefined,
          mobilePhone: undefined,
          gender: undefined,
          specialistSpecial: undefined,
          companyName: undefined,
          specialistTitle: undefined,
          companyTel: undefined,
          birthday: undefined,
          educationalFile: undefined,
          companyContacts: undefined,
          companyPost: undefined,
          degreeFiles: undefined,
          specialistTitleId: undefined,
          companyContactsTel: undefined,
          degreeLevel: undefined,
          positionalFiles: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          hotFlag: undefined,
          userId: undefined,
          areaId: undefined,
          hotScore: undefined,
          industryName: undefined,
          relateId: undefined,
          areaName: undefined,
          industryId: undefined,
          specializedField: undefined,
          starFlag: undefined,
          stationIds: undefined,
          associationStation: undefined,
          identityCardNo: undefined,
          mainBusiness: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          serviceObjectName: undefined,
          signYear: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          serviceUserRequirement: undefined,
          isDatasourceInit: false,
          servicePhoto: undefined
        }
      },
      rules: {
        // 'Specialist.specialistName': [
        //   {required: true, message: '请输入姓名', trigger: 'change'}
        // ],
        // 'Specialist.birthday': [
        //   {required: true, message: '请选择出生日期', trigger: 'change'}
        // ],
        // 'Specialist.industryId': [
        //   {required: true, message: '请选择专业领域', trigger: 'change'}
        // ],
        // 'Specialist.mobilePhone': [
        //   {required: true, message: '请输入联系电话', trigger: 'change'}
        // ],
        //
        // 'Specialist.teamName': [
        //   {required: true, message: '请输入团队名称', trigger: 'change'}
        // ],
        //
        // 'Specialist.identityCardNo': [
        //   {required: true, message: '请输入法人识别号', trigger: 'change'}
        // ]
      },
      fit: 'scale-down',
      signContractWin: {
        formFilter: {
        },
        formFilterCopy: {
        },
        serviceAreaId: {
          impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        contractFiles: {
          impl: new UploadWidget(1)
        },
        attachedFiles: {
          impl: new UploadWidget(10)
        },
        menuBlock: {
          isInit: false
        },
        isInit: false
      },
      flowSpecialistAuditForm: {
        formFilter: {
        },
        formFilterCopy: {
        },
        appropriateChannel: {
          impl: new DropdownWidget(this.loadAppropriateChannelDropdownList)
        },
        specialistType: {
          impl: new DropdownWidget(this.loadSpecialistTypeDropdownList)
        },
        specialistAvatar: {
          impl: new UploadWidget(1)
        },
        idPhoto: {
          impl: new UploadWidget(1)
        },
        gender: {
          impl: new DropdownWidget(this.loadGenderDropdownList)
        },
        industryId: {
          impl: new DropdownWidget(this.loadIndustryIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        degreeLevel: {
          impl: new DropdownWidget(this.loadDegreeLevelDropdownList)
        },
        education: {
          impl: new DropdownWidget(this.loadEducationDropdownList)
        },
        specialistTitleId: {
          impl: new DropdownWidget(this.loadSpecialistTitleIdDropdownList)
        },
        educationalFile: {
          impl: new UploadWidget(1)
        },
        degreeFiles: {
          impl: new UploadWidget(1)
        },
        positionalFiles: {
          impl: new UploadWidget(1)
        },
        servicePhoto: {
          impl: new UploadWidget(1)
        },
        // serviceAreaId: {
        //   impl: new DropdownWidget(this.loadServiceAreaIdDropdownList, true, 'id', 'parentId'),
        //   value: []
        // },
        otherFiles: {
          impl: new UploadWidget(10)
        },
        stationIds: {
          impl: new DropdownWidget(this.loadStationIdsDropdownList)
        },
        areaId: {
          impl: new DropdownWidget(this.loadAreaIdDropdownList, true, 'id', 'parentId'),
          value: []
        },
        hotFlag: {
          impl: new DropdownWidget(this.loadHotFlagDropdownList)
        },
        starFlag: {
          impl: new DropdownWidget(this.loadStarFlagDropdownList)
        },
        SpecialistMember: {
          impl: new TableWidget(this.loadSpecialistMemberWidgetData, this.loadSpecialistMemberVerify, true, false)
        },
        documentType: {
          impl: new DropdownWidget(this.loadDocumentTypeDropdownList)
        },
        identity: {
          impl: new DropdownWidget(this.loadIdentityDropdownList)
        },
        isDistrict: {
          impl: new DropdownWidget(this.loadIsDistrictDropdownList)
        },
        isInit: false
      },
      myLabel: {
        specialistNameLabel: '姓名',
        specialistAvatarLabel: '照片',
        specialistSpecialLabel: '专家特长简介',
        identityCardNoLabel: '身份证号'
      },
      myFlag: {
        birthdayFlag: true
      },
      hisTab: {
        formFilter: {
        },
        formFilterCopy: {
        },
        // SpecialistHis: {
        //   impl: new TableWidget(this.loadSpecialistHisWidgetData, this.loadSpecialistHisVerify, true, true, 'createTime', 1)
        // },
        isInit: false
      }
    }
  },
  methods: {
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    /**
     * 专家类型下拉数据获取函数
     */
    loadSpecialistTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSpecialistTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 拨付渠道下拉数据获取函数
     */
    loadAppropriateChannelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAppropriateChannelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家类型选中值改变
     */
    onSpecialistTypeValueChange (value) {
      /* if (value === '2') {
        // 团队
        this.myLabel.specialistNameLabel = '发起人姓名';
        this.myLabel.specialistSpecialLabel = '团队简介';
      } else if (value === '3') {
        // 法人
        this.myLabel.specialistNameLabel = '法人名称';
        this.myLabel.specialistSpecialLabel = '法人简介';
      } else {
        this.myLabel.specialistNameLabel = '姓名';
        this.myLabel.specialistSpecialLabel = '专家特长简介';
      } */

      if (value === '2') {
        // 团队
        this.myLabel.specialistNameLabel = '发起人姓名';
        this.myLabel.specialistSpecialLabel = '团队简介';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: true, message: '请输入团队名称', trigger: 'change' }]
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.birthday')
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      } else if (value === '3') {
        // 法人
        this.myLabel.specialistNameLabel = '法人名称';
        this.myLabel.specialistSpecialLabel = '法人简介';
        this.rules['Specialist.identityCardNo'] = [{ required: true, message: '请输入法人识别号', trigger: 'change' }]
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: false, message: '请选择专业领域', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.industryId')
        this.rules['Specialist.mobilePhone'] = [{ required: false, message: '请输入联系电话', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.mobilePhone')
        this.rules['Specialist.birthday'] = [{ required: false, message: '请选择出生日期', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.birthday')
      } else {
        this.myLabel.specialistNameLabel = '姓名';
        this.myLabel.specialistSpecialLabel = '专家特长简介';
        this.rules['Specialist.identityCardNo'] = [{ required: false, message: '请输入法人识别号', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.identityCardNo')
        this.rules['Specialist.teamName'] = [{ required: false, message: '请输入团队名称', trigger: 'change' }]
        this.$refs.specialistPage.validateField('Specialist.teamName')
        this.rules['Specialist.industryId'] = [{ required: true, message: '请选择专业领域', trigger: 'change' }]
        this.rules['Specialist.birthday'] = [{ required: true, message: '请选择出生日期', trigger: 'change' }]
        this.rules['Specialist.mobilePhone'] = [{ required: true, message: '请输入联系电话', trigger: 'change' }]
      }
      // 个人才要填生日
      this.myFlag.birthdayFlag = true;
      if (value !== '1') {
        this.myFlag.birthdayFlag = false;
      }
    },
    /**
     * 性别下拉数据获取函数
     */
    loadGenderDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictGenderDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 性别选中值改变
     */
    onGenderValueChange (value) {
    },
    /**
     * 专业领域下拉数据获取函数
     */
    loadIndustryIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIndustryDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专业领域选中值改变
     */
    onIndustryIdValueChange (value) {
      this.formData.Specialist.industryId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 所在地区下拉数据获取函数
     */
    loadServiceAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 所在地区选中值改变
     */
    onServiceAreaIdValueChange (value) {
      this.formData.SpecialistHis.serviceAreaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 学位下拉数据获取函数
     */
    loadDegreeLevelDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDegreeLevelDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 学位选中值改变
     */
    onDegreeLevelValueChange (value) {
    },
    /**
     * 学历下拉数据获取函数
     */
    loadEducationDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictEducationDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 学历选中值改变
     */
    onEducationValueChange (value) {
    },
    /**
     * 职称下拉数据获取函数
     */
    loadSpecialistTitleIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysTitlesDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 职称选中值改变
     */
    onSpecialistTitleIdValueChange (value) {
    },

    /**
     * 派驻站点下拉数据获取函数
     */
    loadStationIdsDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 派驻站点选中值改变
     */
    onStationIdsValueChange (value) {
    },
    /**
     * 地区ID下拉数据获取函数
     */
    loadAreaIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictAreaDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 地区ID选中值改变
     */
    onAreaIdValueChange (value) {
      this.formData.Specialist.areaId = Array.isArray(value) ? value[value.length - 1] : undefined;
    },
    /**
     * 证件类型下拉数据获取函数
     */
    loadDocumentTypeDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDocumentTypeDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 证件类型选中值改变
     */
    onDocumentTypeValueChange (value) {
    },
    /**
     * 身份下拉数据获取函数
     */
    loadIdentityDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictIdentityDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 身份选中值改变
     */
    onIdentityValueChange (value) {
    },
    /**
     * 区级下拉数据获取函数
     */
    loadIsDistrictDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictDistrictDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 区级选中值改变
     */
    onIsDistrictValueChange (value) {
    },
    /**
     * 是否明星专家下拉数据获取函数
     */
    loadStarFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否明星专家选中值改变
     */
    onStarFlagValueChange (value) {
    },
    /**
     * 是否热门专家下拉数据获取函数
     */
    loadHotFlagDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictYesOrNoDict(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 是否热门专家选中值改变
     */
    onHotFlagValueChange (value) {
    },
    /**
     * 更新专家详情
     */
    refreshSpecialistPage (reloadData = false) {
      this.loadSpecialistData().then(res => {
        if (!this.specialistPage.isInit) {
          // 初始化下拉数据
          this.specialistPage.specialistType.impl.onVisibleChange(true).catch(e => {});
          this.specialistPage.serviceAreaId.impl.onVisibleChange(true).then(res => {
            this.specialistPage.serviceAreaId.value = findTreeNodePath(res, this.formData.Specialist.serviceAreaId, 'id');
          }).catch(e => {});
          this.specialistPage.starFlag.impl.onVisibleChange(true).catch(e => {});
          this.specialistPage.hotFlag.impl.onVisibleChange(true).catch(e => {});
        }
        this.specialistPage.isInit = true;
      }).catch(e => {});
    },
    /**
     * 专家对接历史数据获取函数，返回Promise
     */
    loadSpecialistHisWidgetData (params) {
      if (params == null) params = {};
      let _specialistId = this.id;
      if (_specialistId === undefined) {
        _specialistId = -1;
      }
      params = {
        ...params,
        specialistHisDtoFilter: {
          specialistId: _specialistId,
          auditStatus: '1'
        }
      }
      return new Promise((resolve, reject) => {
        SpecialistHisController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.hisTab.SpecialistHis.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.hisTab.SpecialistHis.impl.currentRow.id, 'id');
              this.$refs.specialistHis.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 专家对接历史数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadSpecialistHisVerify () {
      return true;
    },
    /**
     * 更新服务历史
     */
    refreshHisTab (reloadData = false) {
      if (reloadData) {
        this.hisTab.SpecialistHis.impl.refreshTable(true, 1);
      } else {
        this.hisTab.SpecialistHis.impl.refreshTable();
      }
      if (!this.hisTab.isInit) {
        // 初始化下拉数据
      }
      this.hisTab.isInit = true;
    },
    /**
     * 查看编辑
     */
    onSignContractWinClick (row) {
      let params = {
        id: row.id,
        specialistId: row.specialistId
      };

      this.$dialog.show('查看编辑', signContractWin, {
        area: '800px'
      }, params).then(res => {
        this.hisTab.SpecialistHis.impl.refreshTable();
      }).catch(e => {});
    },
    // onResume () {
    //   let activeFragment = this.getActiveFragment();
    //   if (activeFragment != null) activeFragment.refresh();
    // },
    /**
     * 获取专家主表详细信息
     */
    loadSpecialistData () {
      let that = this
      return new Promise((resolve, reject) => {
        // if (!this.formData.Specialist.isDatasourceInit) {
        // if (
        //   this.id == null
        // ) {
        //   this.resetFormData();
        //   reject();
        //   return;
        // }
        let params = {
          id: this.id
        };
        let httpCall = null;
        let specialistType = '1'
        if (this.viewFlag === 1) {
          // 草稿数据
          httpCall = SpecialistInfoController.view(this, params)
        } else {
          httpCall = SpecialistEveryoneController.view(this, params)
          specialistType = '4'
        }
        httpCall.then(res => {
          if (!res.data.specialistType) {
            res.data.specialistType = specialistType
          }
          this.formData.Specialist = {...res.data, isDatasourceInit: true};

          if (res.data.specialistType === '2' && that.formData.Specialist.specialistMemberList.size > 0) {
            that.formData.Specialist.specialistMemberList = res.data.specialistMemberList
            that.flowSpecialistAuditForm.SpecialistMember.impl.dataList = res.data.specialistMemberList
            that.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = res.data.specialistMemberList.length
          }
          let specialistAvatarDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'specialistAvatar',
            asImage: true
          }

          this.flowSpecialistAuditForm.specialistAvatar.impl.fileList = this.parseUploadData(this.formData.Specialist.specialistAvatar, specialistAvatarDownloadParams);

          let idPhotoDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'idPhoto',
            asImage: true
          }
          this.flowSpecialistAuditForm.idPhoto.impl.fileList = this.parseUploadData(this.formData.Specialist.idPhoto, idPhotoDownloadParams);

          this.flowSpecialistAuditForm.gender.impl.onVisibleChange(true).catch(e => {});
          let educationalFileDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'educationalFile',
            asImage: true
          }
          this.flowSpecialistAuditForm.educationalFile.impl.fileList = this.parseUploadData(this.formData.Specialist.educationalFile, educationalFileDownloadParams);
          let degreeFilesDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'degreeFiles',
            asImage: true
          }
          this.flowSpecialistAuditForm.degreeFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.degreeFiles, degreeFilesDownloadParams);
          let positionalFilesDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'positionalFiles',
            asImage: true
          }
          this.flowSpecialistAuditForm.positionalFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.positionalFiles, positionalFilesDownloadParams);
          let servicePhotoDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'servicePhoto',
            asImage: true
          }
          this.flowSpecialistAuditForm.servicePhoto.impl.fileList = this.parseUploadData(this.formData.Specialist.servicePhoto, servicePhotoDownloadParams);

          let otherFilesDownloadParams = {
            id: this.formData.Specialist.id,
            fieldName: 'otherFiles',
            asImage: false
          }
          // if (!this.formData.Specialist.specialistMemberList) {
          //   this.formData.Specialist.specialistMemberList = []
          // }
          this.flowSpecialistAuditForm.specialistType.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.appropriateChannel.impl.onVisibleChange(true).catch(e => {});
          // this.flowSpecialistAuditForm.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
          // this.flowSpecialistAuditForm.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
          this.flowSpecialistAuditForm.otherFiles.impl.fileList = this.parseUploadData(this.formData.Specialist.otherFiles, otherFilesDownloadParams);
          this.flowSpecialistAuditForm.stationIds.impl.onVisibleChange(true).catch(e => {});

          this.flowSpecialistAuditForm.degreeLevel.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.industryId.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.specialistTitleId.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.identity.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.isDistrict.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.documentType.impl.onVisibleChange(true).catch(e => {});
          this.flowSpecialistAuditForm.education.impl.onVisibleChange(true).catch(e => {});

          // this.onSpecialistTypeValueChange(this.formData.Specialist.specialistType)

          // this.specialistPage.starFlag.impl.onVisibleChange(true).catch(e => {});
          // this.specialistPage.hotFlag.impl.onVisibleChange(true).catch(e => {});
          if (this.formData.Specialist.specialistType !== '4') {
            let params2 = {
              specialistHisDtoFilter: {
                specialistInfoId: this.formData.Specialist.id
              }
            }
            // 获取服务签约信息
            SpecialistHisController.list(this, params2).then(res => {
              if (res.data.dataList.length > 0) {
                that.formData.SpecialistHis = res.data.dataList[0]
                let contractFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'contractFiles',
                  asImage: false
                }

                let attachedFilesDownloadParams = {
                  id: that.formData.SpecialistHis.id,
                  fieldName: 'attachedFiles',
                  asImage: false
                }

                that.signContractWin.serviceAreaId.impl.onVisibleChange(true).catch(e => {});
                that.signContractWin.contractFiles.impl.fileList =
                    that.parseUploadData(that.formData.SpecialistHis.contractFiles, contractFilesDownloadParams);
                that.signContractWin.attachedFiles.impl.fileList =
                    that.parseUploadData(that.formData.SpecialistHis.attachedFiles, attachedFilesDownloadParams);
              }
            })
          }

          resolve();
        }).catch(e => {
          reject();
        });
        // } else {
        //   this.formData.Specialist.isDatasourceInit = true;
        //   resolve();
        // }
      });
    },
    /**
     * 删除
     */
    onDeleteClick (row, index) {
      this.$confirm('是否删除?').then(res => {
        index = (this.currentPage - 1) * this.PageSize + index
        this.formData.Specialist.specialistMemberList.splice(index, 1);
        console.log('删除row', row, index)
        this.$message.success('删除成功');
        this.specialistPage.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.specialistPage.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        this.specialistPage.SpecialistMember.impl.refreshTable();
      }).catch(e => {});
    },
    /**
     * 编辑
     */
    onSpecialistMemberEditClick (row, index) {
      let params = {
        specialistMemberForm: row
      };
      console.log('indexindexindexindexindex', this.currentPage, index)
      this.$dialog.show('编辑', specialistMemberEdit, {
        area: '800px'
      }, params).then(res => {
        if (index === -1) {
          this.$message.success('编辑失败');
        } else {
          index = (parseInt(this.currentPage) - 1) * this.PageSize + index
          this.formData.Specialist.specialistMemberList[index] = res.specialistMemberDto
          console.log('totalAmount11111111111111', index, this.formData.Specialist.specialistMemberList[index], this.formData.Specialist.specialistMemberList, this.formData.Specialist.specialistMemberList)
          this.specialistPage.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
          this.specialistPage.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
          this.refreshSpecialistMemberList();
          // this.budgetDetailPage.BudgetDetail.impl.refreshTable();
          this.specialistPage.SpecialistMember.impl.refreshTable();
          this.formData.Specialist.specialistMemberList.splice(1, 0);
        }
      }).catch(e => {});
    },
    /**
     * 新增
     */
    addSpecialistMember () {
      let params = {};

      this.$dialog.show('新增', specialistMemberForm, {
        area: '800px'
      }, params).then(res => {
        console.log('resresresresresres', res, this.formData.Specialist.specialistMemberList)
        var size = this.formData.Specialist.specialistMemberList.length
        console.log('sizesizesize', size)
        this.formData.Specialist.specialistMemberList[size] = res.specialistMemberDto
        console.log('this.formData.Specialist.specialistMemberList', this.formData.Specialist.specialistMemberList)
        this.specialistPage.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
        this.specialistPage.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
        this.refreshSpecialistMemberList();
        this.formData.Specialist.specialistMemberList.splice(1, 0);
      }).catch(e => {});
    },
    /**
     * 更新团队成员列表
     */
    refreshSpecialistMemberList (reloadData = false) {
      this.specialistPage.SpecialistMember.impl.dataList = this.formData.Specialist.specialistMemberList
      this.specialistPage.SpecialistMember.impl.totalCount = this.formData.Specialist.specialistMemberList.length
      this.specialistPage.SpecialistMember.impl.refreshTable();
    },
    handleSizeChange (val) {
      // 改变每页显示的条数
      this.PageSize = val
      // 在改变每页显示的条数时，要将页码显示到第一页
      this.currentPage = 1
    },
    // 显示第几页
    handleCurrentChange (val) {
      // 改变默认的页数
      this.currentPage = val
    },
    /**
     * 获取专家对接历史详细信息
     */
    initFormData () {
    },
    buildFragmentPermCodeMap () {
      this.permCodeList = [
        {
          key: 'specialistPage',
          permCode: 'specialistPage:specialistPage',
          refresh: this.refreshSpecialistPage
        },
        {
          key: 'hisTab',
          permCode: 'specialistPage:hisTab',
          refresh: this.refreshHisTab
        }
      ];
    },

    // getActiveFragment () {
    //   for (let i = 0; i < this.permCodeList.length; i++) {
    //     if (this.permCodeList[i].key === this.activeFragmentId) {
    //       return this.permCodeList[i];
    //     }
    //   }
    // },
    /**
     * 照片上传成功
     */
    onSpecialistAvatarUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistPage.specialistAvatar.impl.onFileChange(file, fileList);
        this.formData.Specialist.specialistAvatar = this.fileListToJson(this.specialistPage.specialistAvatar.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除照片
     */
    onSpecialistAvatarRemoveFile (file, fileList) {
      this.specialistPage.specialistAvatar.impl.onFileChange(file, fileList);
      this.formData.Specialist.specialistAvatar = this.fileListToJson(this.specialistPage.specialistAvatar.impl.fileList);
    },
    /**
     * 学历资料上传成功
     */
    onEducationalFileUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistPage.educationalFile.impl.onFileChange(file, fileList);
        this.formData.Specialist.educationalFile = this.fileListToJson(this.specialistPage.educationalFile.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除学历资料
     */
    onEducationalFileRemoveFile (file, fileList) {
      this.specialistPage.educationalFile.impl.onFileChange(file, fileList);
      this.formData.Specialist.educationalFile = this.fileListToJson(this.specialistPage.educationalFile.impl.fileList);
    },
    /**
     * 职称资料上传成功
     */
    onPositionalFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistPage.positionalFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.positionalFiles = this.fileListToJson(this.specialistPage.positionalFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除职称资料
     */
    onPositionalFilesRemoveFile (file, fileList) {
      this.specialistPage.positionalFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.positionalFiles = this.fileListToJson(this.specialistPage.positionalFiles.impl.fileList);
    },
    /**
     * 学位资料上传成功
     */
    onDegreeFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistPage.degreeFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.degreeFiles = this.fileListToJson(this.specialistPage.degreeFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除学位资料
     */
    onDegreeFilesRemoveFile (file, fileList) {
      this.specialistPage.degreeFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.degreeFiles = this.fileListToJson(this.specialistPage.degreeFiles.impl.fileList);
    },
    /**
     * 其他附件上传成功
     */
    onOtherFilesUploadSuccess (response, file, fileList) {
      if (response.success) {
        file.downloadUri = response.data.downloadUri;
        file.filename = response.data.filename;
        file.url = URL.createObjectURL(file.raw);
        this.specialistPage.otherFiles.impl.onFileChange(file, fileList);
        this.formData.Specialist.otherFiles = this.fileListToJson(this.specialistPage.otherFiles.impl.fileList);
      } else {
        this.$message.error(response.message);
      }
    },
    /**
     * 移除其他附件
     */
    onOtherFilesRemoveFile (file, fileList) {
      this.specialistPage.otherFiles.impl.onFileChange(file, fileList);
      this.formData.Specialist.otherFiles = this.fileListToJson(this.specialistPage.otherFiles.impl.fileList);
    },
    onUploadError (e, file, fileList) {
      this.$message.error('文件上传失败');
    },
    onUploadLimit (files, fileList) {
      this.$message.error('已经超出最大上传个数限制');
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        SpecialistHis: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistId: undefined,
          specialistName: undefined,
          serviceObjectName: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          mainBusiness: undefined,
          signYear: undefined,
          serviceUserRequirement: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          contractFiles: undefined,
          attachedFiles: undefined,
          isDatasourceInit: false
        },
        Specialist: {
          id: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          orgCode: undefined,
          deletedFlag: undefined,
          specialistType: undefined,
          specialistName: undefined,
          teamName: undefined,
          specialistAvatar: undefined,
          mobilePhone: undefined,
          gender: undefined,
          specialistSpecial: undefined,
          companyName: undefined,
          specialistTitle: undefined,
          companyTel: undefined,
          birthday: undefined,
          educationalFile: undefined,
          companyContacts: undefined,
          companyPost: undefined,
          degreeFiles: undefined,
          specialistTitleId: undefined,
          companyContactsTel: undefined,
          degreeLevel: undefined,
          positionalFiles: undefined,
          otherFiles: undefined,
          auditStatus: undefined,
          hotFlag: undefined,
          userId: undefined,
          areaId: undefined,
          hotScore: undefined,
          industryName: undefined,
          relateId: undefined,
          areaName: undefined,
          industryId: undefined,
          starFlag: undefined,
          stationIds: undefined,
          associationStation: undefined,
          identityCardNo: undefined,
          mainBusiness: undefined,
          serviceType: undefined,
          serviceContent: undefined,
          serviceObjectName: undefined,
          signYear: undefined,
          serviceAreaId: undefined,
          serviceAreaName: undefined,
          contactsUser: undefined,
          contactsUserTel: undefined,
          serviceUserRequirement: undefined,
          isDatasourceInit: false
        }
      }
      this.getDefaultFragment();
    },
    /**
     * 根据权限获取默认显示的fragment
     */
    getDefaultFragment () {
      for (let i = 0; i < this.permCodeList.length; i++) {
        if (this.checkPermCodeExist(this.permCodeList[i].permCode)) {
          this.activeFragmentId = this.permCodeList[i].key;
          return this.permCodeList[i];
        }
      }
      return undefined;
    },
    formInit () {
      // let defaultFragment = this.getDefaultFragment();
      // if (defaultFragment == null) {
      //   this.$message.error('您没有访问这个页面的权限，请与系统管理员联系！');
      // }
    }
  },
  computed: {
    getTabPaneHeight () {
      return (this.getMainContextHeight - 102);
    },
    ...mapGetters(['getMainContextHeight'])
  },
  mounted () {
    this.refreshSpecialistPage();
  },
  created () {
    // this.refreshSpecialistPage()
    // this.buildFragmentPermCodeMap();
  },
  watch: {
  }
}
</script>
<style>
  .el-input.is-disabled .el-input__inner {
    background-color: white!important;
    color: #0f1325!important;
  }
</style>
